import { useMemo } from 'react';
import { type TFunction } from 'i18next';

import { titleCase } from '@cx-modules/utils';

import { type Teams } from '../types';

import { useTeams } from './useTeams';

export const useTeamNickNameFromBet = (genericName: string, t: TFunction, category: string) => {
  const teams = useTeams();
  const betKey = genericName?.toLowerCase();
  return useMemo(() => {
    if (!teams || !betKey) {
      return '';
    }
    if (betKey === 'draw') {
      let attempt = t('Draw', { defaultValue: 'NOT_FOUND', ns: category });

      if (attempt === 'NOT_FOUND') {
        attempt = t('DRAW', { ns: category });
      }
      return titleCase(attempt);
    }

    if (betKey in teams) {
      const nickNameFromBet = teams[betKey as keyof Teams]?.nickName;
      const nameFromBet = teams[betKey as keyof Teams]?.name;

      if (!nickNameFromBet) {
        return titleCase(t(titleCase(nameFromBet), { ns: category }));
      } else {
        return titleCase(t(titleCase(nickNameFromBet), { ns: category }));
      }
    }

    return '';
  }, [category, betKey, t, teams]);
};
